const initialState = {
  selectedPackage: {},
  selectedAddons: [],
  addons: [],
  prices: {},
  quantity: {},
  packages: [],
  selectedQuota: '',
};

export const packages = {
  state: { ...initialState },
  reducers: {
    updateSelectedQuota(state, payload) {
      return {
        ...state,
        selectedQuota: payload,
      };
    },
    updateSelectedPackage(state, payload) {
      return {
        ...state,
        selectedPackage: { ...state.selectedPackage, ...payload },
      };
    },
    updateProducts(state, payload) {
      return {
        ...state,
        packages: payload,
      };
    },
    updateSelectedAddons(state, payload) {
      const checkedData =
        state.selectedAddons.find((selected) => selected.id === payload.id) ||
        state.selectedAddons.find((selected) => selected.name === payload.name);
      let filteredSelection;
      if (checkedData) {
        const currfilteredSelection = state.selectedAddons
          .filter((selection) => selection.name.toLowerCase() !== payload.name.toLowerCase())
          .filter((selected) => selected.id !== payload.id);
        if (payload?.type === 'checkbox' && !payload.checked) {
          filteredSelection = currfilteredSelection;
        } else {
          filteredSelection = [...currfilteredSelection, payload];
        }
      } else {
        filteredSelection = [...state.selectedAddons, payload];
      }

      return {
        ...state,
        selectedAddons: filteredSelection,
      };
    },
    updateAllSelectedAddons(state, payload) {
      return {
        ...state,
        selectedAddons: payload,
      };
    },
    updateAddons(state, payload) {
      return {
        ...state,
        addons: [...state.addons, ...payload],
      };
    },
    updateAddonsQuantity(state, payload) {
      return {
        ...state,
        quantity: { ...state.quantity, ...payload },
      };
    },
    updatePrice(state, payload) {
      return {
        ...state,
        prices: { ...state.prices, ...payload },
      };
    },
    clearPackages() {
      return {
        ...initialState,
      };
    },
    removeAll(state, payload) {
      const checkedData = state.selectedAddons.find((selected) => selected.name === payload);
      let filteredSelection;
      if (checkedData) {
        filteredSelection = state.selectedAddons.filter(
          (selection) => selection.name.toLowerCase() !== payload.toLowerCase()
        );
      } else {
        filteredSelection = state.selectedAddons;
      }
      return {
        ...state,
        selectedAddons: filteredSelection,
      };
    },
  },
};
